import { apiClient } from '../../shared/api/apiClient';
import {
    ListCommentsResponseSchema, CommentResponseSchema, ToggleReactionResponseSchema,
    DeleteCommentResponseSchema, ToggleMediaVisibilityResponseSchema,
} from './schemas';

export const commentsApi = {
    list: (docId) => apiClient.get(`/api/comments/${docId}`).then((d) => ListCommentsResponseSchema.parse(d)),
    create: (payload) => apiClient.post('/api/comments', payload).then((d) => CommentResponseSchema.parse(d)),
    update: (commentId, content) => apiClient.post('/api/comments/update', { comment_id: commentId, content }).then((d) => CommentResponseSchema.parse(d)),
    // Mezcla metadata sin tocar
    // `content` -- usado hoy para anclar un recordatorio (`{reminder: {...}}`) a un comentario
    // de tarea ya existente.
    updateMetadata: (commentId, metadata) => apiClient.post('/api/comments/update-metadata', { comment_id: commentId, metadata }).then((d) => CommentResponseSchema.parse(d)),
    react: (commentId, userId) => apiClient.post('/api/comments/reaction', { comment_id: commentId, user_id: userId }).then((d) => ToggleReactionResponseSchema.parse(d)),
    remove: (commentId) => apiClient.del(`/api/comments/${commentId}`).then((d) => DeleteCommentResponseSchema.parse(d)),
    // Toggle público/privado de un archivo embebido en un comentario -- mismo endpoint
    // compartido usado por docs/dataindex/tareas (se retiró la ruta task-específica, que
    // hacía exactamente lo mismo una vez que los comentarios de tarea son filas reales).
    toggleMediaVisibility: (commentId, mediaKey, access) =>
        apiClient.patch(`/api/comments/${commentId}/media/${mediaKey}/visibility`, { access }).then((d) => ToggleMediaVisibilityResponseSchema.parse(d)),
    markAsRead: (commentIds) => apiClient.post('/api/comments/read', { commentIds }),
};
